import numTrim from '../../helpers/numTrim'

export default function (value) {
  if (!value) return ''
  value = numTrim(value.toString())

  if (value.length === 12) value = '+' + value
  return 'tel:' + value
}
